const TYPES = {
  RESET_CURRENT_PAGE: 'RESET_CURRENT_PAGE',
  RESET_TABLE_DATA: 'RESET_TABLE_DATA',
  RESET_TABLE_SEARCH: 'RESET_TABLE_SEARCH',
  SET_TABLE_FILTERS: 'SET_TABLE_FILTERS',
  SET_TABLE_DEFAULT_REQUEST_PARAMS: 'SET_TABLE_DEFAULT_REQUEST_PARAMS'
};

export default TYPES;
